import http from '../../../services/api'
import type { APIPaginatedResponse, APIResponse, Filters, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'

const apiPath = import.meta.env.VITE_API_PATH

export type StockInItemPayload = {
  item_uuid: string
  quantity: number
  unit_uuid?: string
  unit_cost: number
  batch_number?: string
  expiry_date?: string
  serials?: string[]
  bar_code?: string
}

export type StockInPayload = {
  location_id: number
  reference_type: number
  supplier_uuid?: string | null
  reference_number?: string
  stockin_date: string
  notes?: string
  opening_date?: string
  items: StockInItemPayload[]
}

/**
 * Persists a new stock-in header and its line items.
 * @param input - Validated payload aligned with the inventory stock-in API contract.
 * @returns Axios response wrapping the API envelope for the created record(s).
 */
async function createStockIn(input: StockInPayload) {
  return await http.post<APIResponse<any>>(apiPath + 'inventory/stock-in', input)
}

/**
 * Loads paginated stock-in history (same filter/pagination query shape as other list endpoints).
 * @param filters - Optional column/search and date filters from the shared `Table` widget.
 * @param pagination - Current page and page size.
 * @returns Axios response whose `data` is expected to be a Laravel paginator JSON payload.
 */
async function getStockInHistory(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getRequestParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<Record<string, unknown>>>(
    apiPath + 'inventory/stock-in-history' + paramString,
    {
      errorHandle: false,
    } as any,
  )
}

const stockInService = {
  createStockIn,
  getStockInHistory,
}

export default stockInService
